import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../../../../uiToolkit/PageTitle';
import SearchInput2 from '../../../../uiToolkit/Inputs/SearchInput2/SearchInput2';
import Button from '../../../../uiToolkit/Buttons/Button';
import LoadingSpinner from '../../../../uiToolkit/LoadingSpinner/LoadingSpinner';
import ProjectsEmptyState from '../../../../uiToolkit/EmptyStates/ProjectsEmptyState';
import {Project} from '../../../../data/models/Projects/Project';
import {projectsText} from '../../projectsText';
import ProjectCard from '../components/ProjectCard';
import styles from './ProjectsListUI.module.css';

interface Props {
  projects: Project[];
  isLoading: boolean;
  canManage: boolean;
  search: string;
  setSearch: (search: string) => void;
  onCreate: () => void;
  onOpen: (project: Project) => void;
  onRename: (project: Project) => void;
  onDelete: (project: Project) => void;
}

const ProjectsListUI = React.memo(
  ({
    projects,
    isLoading,
    canManage,
    search,
    setSearch,
    onCreate,
    onOpen,
    onRename,
    onDelete,
  }: Props) => {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <PageTitle title={projectsText.title} />
          <div className={styles.filters}>
            <SearchInput2
              value={search}
              onTyping={setSearch}
              onSearch={setSearch}
              className={styles.search}
            />
            {canManage && (
              <Button
                title={projectsText.newProject}
                onClick={onCreate}
                uiType="action"
                icon="icon-plus"
              />
            )}
          </div>
        </div>
        <Container fluid className={styles.list}>
          <Row>
            {projects.length ? (
              projects.map(project => (
                <Col xl={3} lg={4} key={project.id} className={styles.col}>
                  <ProjectCard
                    project={project}
                    canManage={canManage}
                    onOpen={onOpen}
                    onRename={onRename}
                    onDelete={onDelete}
                  />
                </Col>
              ))
            ) : isLoading ? (
              <Col xl={12} lg={12}>
                <div className={styles.loading}>
                  <LoadingSpinner size={48} />
                </div>
              </Col>
            ) : (
              <Col xl={12} lg={12}>
                <ProjectsEmptyState
                  title={
                    search
                      ? projectsText.searchEmptyTitle
                      : projectsText.emptyTitle
                  }
                  subtitle={
                    search
                      ? projectsText.searchEmptySubtitle
                      : projectsText.emptySubtitle
                  }
                />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  },
);

export default ProjectsListUI;
